module.exports = "\n<admin-home *ngIf=\"showAdminHome\"></admin-home>\n\n<devotee-home *ngIf=\"!showAdminHome\"></devotee-home>\n\n<!--<devotee-login></devotee-login>-->"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main